import SegmentAnalytics from '../../../helpers/SegmentAnalytics.js';

class User {
  currentUser = undefined;

  constructor(parent) {
    this.parent = parent;
  }

  get isClinician() {
    return !!(this.currentUser && this.currentUser.accountType === 'clinician');
  }

  get isLoggedIn() {
    return !!(this.currentUser);
  }

  logIn(user, update = true) {
    this.currentUser = user;
    SegmentAnalytics.identify(user.id, user);

    if (update) this.update();
  }

  logOut() {
    this.currentUser = undefined;
    this.update();
  }

  update() {
    this.parent.setState({ user: this });
  }
}

export default User;
